/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Step from '../../../components/Step/Step';
import './style.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { CarrinhoContext } from '../../../context/Carrinho/CarrinhoContext';
import { useApi } from '../../../hooks/userApi';
import { MenuItem, OutlinedInput, Select } from '@mui/material';
import { LoadingContext } from '../../../context/Loading/LoadingContext';
import { formatDinheiro } from '../../../utils/formatDinheiro';
import { eventManager, UPDATE_EVENTS } from '../../../utils/eventManager';
import React from 'react';
import assets from '../../../assets';
import { format, formatISO, parseISO, startOfDay } from 'date-fns';

const api = useApi();

const Title = (props) => {
  return (
    <div className="search">
      <div className="title">{props.title}</div>
      {/* <div className="inputSearch">
        <InputBase
          sx={{ p: "5px" }}
          fullWidth
          placeholder="Busque por um produto"
          inputProps={{ "aria-label": "busque por um produto" }}
        />
        <IconButton
          type="button"
          sx={{ p: "5px", color: "green" }}
          aria-label="search"
        >
          <SearchIcon />
        </IconButton>
      </div> */}
    </div>
  );
};

const DetalhesCliente = (props) => {
  const data = startOfDay(new Date()); 
  const hoje = format(data, 'yyyy-MM-dd');
  const [arquivoNome, setArquivoNome] = useState('');
  const textFieldRef = React.useRef(null);
  const textFieldRef2 = React.useRef(null);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  useEffect(() => {
    const handleWheel = (e) => e.preventDefault();

    if (textFieldRef.current) {
      textFieldRef?.current?.addEventListener('wheel', handleWheel);
    }
    return () => {
      textFieldRef?.current?.removeEventListener('wheel', handleWheel);
    };
  }, []);

  useEffect(() => {
    const handleWheel = (e) => e.preventDefault();

    if (textFieldRef2.current) {
      textFieldRef2?.current?.addEventListener('wheel', handleWheel);
    }
    return () => {
      textFieldRef2?.current?.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <Box component="form" noValidate autoComplete="off">
      <div className="inputControl">
        Nome do Cliente
        <TextField
          disabled
          // label="Disabled"
          defaultValue={props.nome}
        />
      </div>
      <div className="inputControl">
        Telefone do Cliente
        <TextField
          disabled
          // label="Disabled"
          defaultValue={props.telefone}
        />
      </div>
      <div className="inputControl">
        Valor do frete em R$
        <TextField
          type="number"
          // inputProps={{ inputmode: "numeric", pattern: "[0-9]*" }}
          defaultValue={props.freteFixo}
          onChange={(e) => {
            const n = Number(e.target.value);
            props.handFreteFixo(n);
          }}
          ref={textFieldRef2}
        />
      </div>
      <div className="inputControl">
        Desconto
        <TextField
          type="number"
          // inputProps={{ inputmode: "numeric", pattern: "[0-9]*" }}
          defaultValue={props.freteDesconto}
          onWheel={(event) => {
            event.preventDefault();
          }}
          onChange={(e) => {
            const n = Number(e.target.value);
            props.handFreteDesconto(n);
          }}
          ref={textFieldRef}
        />
      </div>
      <div className="inputControl">
        Validade da proposta
        <TextField
          type="date"
          defaultValue={hoje}
          onChange={(e) => props.handValidade(e.target.value)}
        />
      </div>

      <div className="inputControl">
        Condição de pagamento
        <TextField
          id="pagamento"
          select
          defaultValue="a12d"
          onChange={(e) => props.handPagamento(e.target.value)}
        >
          <MenuItem key={'a12d'} value="a12d" disabled>
            Selecione o método de pagamento
          </MenuItem>
          {props.pagamento.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.nome}
            </MenuItem>
          ))}
        </TextField>
      </div>

      {props.condicao && (
        <div className="inputControl">
          Condição de negociação
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            displayEmpty
            value={props.negociacao}
            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>Seleção de condição</em>;
              }
              return selected.join(', ');
            }}
            onChange={(e) => props.handNegociacao(e.target.value)}
            MenuProps={MenuProps}
          >
            {props.condicao.map((option) => (
              <MenuItem key={option.id} value={option.nome}>
                <Checkbox
                  checked={props.negociacao.indexOf(option.nome) > -1}
                />
                <ListItemText primary={option.nome} />
              </MenuItem>
            ))}
          </Select>
        </div>
      )}
      <div className="inputControl">
        Despesas em R$
        <TextField
          type="number"
          // inputProps={{ inputmode: "numeric", pattern: "[0-9]*" }}
          defaultValue={props.despesas}
          onChange={(e) => {
            const n = Number(e.target.value);
            props.handDespesas(n);
          }}
          ref={textFieldRef2}
        />
      </div>
      <div className="inputControl">
        Prazo de Embarque
        <TextField
          type="date"
          defaultValue={hoje}
          onChange={(e) => props.handEmbarque(e.target.value)}
        />
      </div>
      <div className="inputControl">
        <input
          accept="image/*, .pdf, .cdr"
          name="file"
          style={{ display: 'none' }}
          id="button-file"
          type="file"
          onChange={(e) => {
            setArquivoNome(e.target.files[0].name);
            props.handFile(e.target.files[0]);
          }}
        />
        <div className="inputControl">
          Tipo de Frete
          <Select
            value={props.tipoFrete}
            onChange={(e) => {
              const selectedValue = e.target.value;
              props.setTipoFrete(selectedValue);
            }}
          >
            <MenuItem value="CIF">CIF</MenuItem>
            <MenuItem value="FOB">FOB</MenuItem>
          </Select>
        </div>
        <label htmlFor="button-file" className="file">
          <FileUploadOutlinedIcon style={{ color: '#136033' }} />

          {arquivoNome === '' && (
            <span style={{ color: '#136033', fontWeight: 600 }}>
              Upload de arquivo
            </span>
          )}
          {arquivoNome}
          <span>(5mb máxima)</span>
        </label>
      </div>
    </Box>
  );
};

const DetalhesVendodor = ({ vendedor }) => {
  return (
    <Box component="form" noValidate autoComplete="off">
      <p className="titulos" style={{ marginBottom: 16 }}>
        Dados do revendedor
      </p>
      <p className="vendedor">Nome: {vendedor.nome}</p>
      <p className="vendedor">E-mail: {vendedor.email}</p>
      <p className="vendedor">Contato: {vendedor.contato}</p>
    </Box>
  );
};

const DetalhesCompra = ({
  produtos,
  somaProdutos,
  freteFixo,
  descontoFrete,
  despesas,
  clienteCar,
  updateProdutoQuantidade // Add this new prop
}) => {
  const navigate = useNavigate();
  const textFieldRef = React.useRef(null);

  // Add wheel event handler to prevent scrolling on number inputs
  useEffect(() => {
    const handleWheel = (e) => e.preventDefault();

    if (textFieldRef.current) {
      textFieldRef?.current?.addEventListener('wheel', handleWheel);
    }
    return () => {
      textFieldRef?.current?.removeEventListener('wheel', handleWheel);
    };
  }, []);

  const pluralProdutos = () => {
    if (produtos.length > 1)
      return (
        <>
          <span>Valor total itens</span>
          <span>{formatDinheiro(somaProdutos.total, 2)}</span>
        </>
      );
    return (
      <>
        <span>Valor total item</span>
        <span>{formatDinheiro(somaProdutos.total, 2)}</span>
      </>
    );
  };

  const handleQuantityChange = (index, newValue) => {
    // Ensure the value is not negative
    const quantity = Math.max(1, parseInt(newValue) || 1);
    updateProdutoQuantidade(index, quantity);
  };

  return (
    <Box>
      <Box className="white-bg">
        <div>
          <div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
              <p className="titulos">Produtos</p>
              <button 
                className="btn-transparent" 
                onClick={() => navigate(`/vendedor/calculoProduto/${clienteCar.id}`, 
                { state: { produtosAtuais: produtos } })}
              >
                Adicionar mais produtos{' '}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM16.5 12C16.5 12.1989 16.421 12.3897 16.2803 12.5303C16.1397 12.671 15.9489 12.75 15.75 12.75H12.75V15.75C12.75 15.9489 12.671 16.1397 12.5303 16.2803C12.3897 16.421 12.1989 16.5 12 16.5C11.8011 16.5 11.6103 16.421 11.4697 16.2803C11.329 16.1397 11.25 15.9489 11.25 15.75V12.75H8.25C8.05109 12.75 7.86033 12.671 7.71967 12.5303C7.57902 12.3897 7.5 12.1989 7.5 12C7.5 11.8011 7.57902 11.6103 7.71967 11.4697C7.86033 11.329 8.05109 11.25 8.25 11.25H11.25V8.25C11.25 8.05109 11.329 7.86032 11.4697 7.71967C11.6103 7.57902 11.8011 7.5 12 7.5C12.1989 7.5 12.3897 7.57902 12.5303 7.71967C12.671 7.86032 12.75 8.05109 12.75 8.25V11.25H15.75C15.9489 11.25 16.1397 11.329 16.2803 11.4697C16.421 11.6103 16.5 11.8011 16.5 12Z" fill="#23C265"/>
                </svg>
              </button>
            </div>
            <List sx={{
              width: '100%',
              maxHeight: 600,
              overflowY: 'auto',
            }}>
              {produtos.map((p, index) => (
                <ListItem
                  sx={{
                    borderBottom: 1,
                    borderColor: '#E0E0E0',
                  }}
                  key={index}
                >
                  <ListItemAvatar>
                    <Avatar variant="square">
                      {p.produto.caracteristicas[0]?.fotos[0]?.imagem ? (
                        <img
                          className="imagem-produto"
                          src={p.produto.caracteristicas[0]?.fotos[0]?.imagem}
                        />
                      ) : (
                        <img
                          className="imagem-produto"
                          src={assets.images.produto}
                        />
                      )}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography style={{ color: '#136033', fontWeight: 600 }}>
                        {p.produto.nome}
                      </Typography>
                    }
                    secondary={
                      p.produto.largura + ' x ' + p.produto.altura + ' mm'
                    }
                  />
                  <TextField
                    type="number"
                    value={p.quantidade}
                    onChange={(e) => handleQuantityChange(index, e.target.value)}
                    inputProps={{ 
                      min: '1',
                      style: { 
                        textAlign: 'center',
                        width: '60px',
                        color: '#136033',
                        fontWeight: 600
                      }
                    }}
                    variant="outlined"
                    size="small"
                    ref={textFieldRef}
                  />
                </ListItem>
              ))}
            </List>
          </div>
        </div>
      </Box>
      <Box className="white-bg">
        <div
          className="bloco-valores"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <p className="titulos">Resumo da compra</p>
          {/* <span>Valor do frete % {formatDinheiro(extras.frete)}</span>
            <span>Valor no frete {formatDinheiro(freteFixo)}</span> */}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {pluralProdutos()}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Valor do frete</span>
            <span>{formatDinheiro(freteFixo, 2)}</span>
          </div>
          {descontoFrete > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>Desconto</span>
              <span>{formatDinheiro(descontoFrete, 2)}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Despesas</span>
            <span>{formatDinheiro(despesas, 2)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span> Valor do IPI total</span>
            <span>{formatDinheiro(somaProdutos.totalIpi, 2)}</span>
          </div>
        </div>
        <div
          className="total"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <span> Total Orçamento</span>
          <span>
            {' '}
            {formatDinheiro(
              somaProdutos.total + freteFixo - descontoFrete + despesas,
              2
            )}
          </span>
        </div>
      </Box>
    </Box>
  );
};

const Checkout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { produtoCar, clienteCar }: any = useContext(CarrinhoContext);
  const {
    loading,
    setLoading,
    setLoadingMensagem,
    setLoadingBtn,
    setLoadingAction,
    setClearLoading,
  }: any = useContext(LoadingContext);
  const savedData = JSON.parse(sessionStorage.getItem('checkoutData'));
  const [pagamento, setPagamento] = useState([]);
  const [observacoes, setObservacoes] = useState('');
  const [despesas, setDespesas] = useState<number>(0);
  const [tipoFrete, setTipoFrete] = useState('CIF');
  const [embarque, setEmbarque] = useState(new Date());
  const [somaProdutos, setSomaProdutos] = useState<any>({});
  const [validade, setValidade] = useState(new Date());
  const [freteFixo, setFreteFixo] = useState<number>(0);
  const [descontoFrete, setDescontoFrete] = useState<number>(0);
  const [pagamentoId, setPagamentoId] = useState({});
  const [fileName, setFileName] = useState('');
  const [listaNegociacao, setListaNegociacao] = useState([]);
  const [negociacao, setNegociacao] = useState<string[]>([]);
  const [vendedor, setVendedor] = useState(JSON.parse(sessionStorage.getItem('user') || '{}'));

  const recarregarVendedor = () => {
    const vendedorAtual = JSON.parse(sessionStorage.getItem('user') || '{}');
    console.log('Recarregando vendedor do sessionStorage:', vendedorAtual);
    setVendedor(vendedorAtual);
  };

  const saveToSession = (data) => {
    try {
      sessionStorage.setItem('checkoutData', JSON.stringify(data));
    } catch (error) {
      console.error('Error saving to sessionStorage:', error);
    }
  };

  const carregaPagamento = async () => {
    setLoading(true);
    try {
      const responses = await api.get('/pagamento');
      if (!responses.status) {
        setLoadingMensagem(
          'Desculpe, não foi possivel carregar modo de pagamento!'
        );
        setLoadingBtn('OK');
        return;
      } else {
        setClearLoading(true);
        setPagamento(responses.results);
      }
    } catch (e) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  const carregaNegociacao = async () => {
    setLoading(true);
    try {
      const responses = await api.get('/negociacao?limit=100');
      if (!responses.status) {
        setLoadingMensagem(
          'Desculpe, não foi possivel carregar a opção de pagamento!'
        );
        setLoadingBtn('OK');
        return;
      }
      setClearLoading(true);
      setListaNegociacao(responses.results);

    } catch (e) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  const items = [
    ['Orçamento', true],
    ['Checkout', true],
    ['Confirmação', false],
    ['PDF', false],
  ];

  const handPagamento = (id) => {
    setPagamentoId(id);
  };  

  const handValidade = (data) => {
    const date = startOfDay(parseISO(data));
    setValidade(date);
    console.log('Validade da proposta ajustada:', date);
  };

  const handEmbarque = (data) => {
    const date = startOfDay(parseISO(data));
    setEmbarque(date);
    console.log('Data de embarque ajustada:', date);
  };

  const handFreteFixo = (v) => {
    v = Number(v);

    v = Math.abs(v);
    setFreteFixo(v);
  };
  const handDespesas = (v) => {
    v = Number(v);

    v = Math.abs(v);
    setDespesas(v);
  };

  const handFreteDesconto = (v) => {
    v = Number(v);

    v = Math.abs(v);

    if (v >= somaProdutos.total + freteFixo) {
      setDescontoFrete(Number(somaProdutos.total + freteFixo));
      return;
    } else setDescontoFrete(v);
  };

  const handFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    setLoading(true);
    try {
      if (file.size / 1024 > 5120) {
        setLoadingMensagem('O arquivo ultrapassa o limite definido de 5mb.');
        setLoadingBtn('OK');
        return;
      }
      if (fileName !== '') await api.delete('/foto/documento/' + fileName);
      const responses = await api.post('/foto/documento', formData);
      setClearLoading(true);
      setFileName(responses.mensagem.foto.imagem);
    } catch (e) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  useEffect(() => {
    carregaPagamento();
    carregaNegociacao();

    const handleVendedorUpdate = () => {
      console.log('Checkout - Evento de atualização de vendedor recebido');
      recarregarVendedor();
    };

    eventManager.addEventListener(UPDATE_EVENTS.VENDEDOR_UPDATED, handleVendedorUpdate);

    return () => {
      eventManager.removeEventListener(UPDATE_EVENTS.VENDEDOR_UPDATED, handleVendedorUpdate);
    };
  }, []);

  const totalOrcamento = async () => {
    let totalparcial = 0;
    await Promise.all(
      produtoCar.map((o) => {
        totalparcial += Number(o.valor) * Number(o.quantidade);
      })
    );

    return totalparcial;
  };

  const somaTotal = (totalParcial) => {
    let total = 0;
    let totalIpi = 0;
    let valorUn = 0;

    Promise.all(
      produtoCar.map((p) => {
        const ipi = Number(p.produto.ipi) / 100;
        const valor = Number(p.valor) * Number(p.quantidade);
        const frete = freteFixo * (valor / totalParcial);

        const freteIpi = Number((frete * ipi).toFixed(2));
        const valorProdutos = Number(Number(p.valor).toFixed(4));
        const produtoIpi = valorProdutos + valorProdutos * ipi;
        p.valorFrete = frete;
        totalIpi += ipi * valor;

        total += Number(
          (produtoIpi * Number(p.quantidade) + freteIpi).toFixed(4)
        );
        valorUn = Number(p.valor);
      })
    ).then(() => {
      setSomaProdutos({
        valorUn: valorUn,
        total: total,
        totalIpi: totalIpi,
        totalParcial: totalParcial,
      });
    });
  };

  const updateProdutoQuantidade = (index: number, quantidade: number) => {
    const updatedProdutos = [...produtoCar];
    updatedProdutos[index].quantidade = quantidade;
    setSomaProdutos((prev) => ({
      ...prev,
      total: updatedProdutos.reduce(
        (acc, item) => acc + item.valor * item.quantidade,
        0
      ),
    }));
  };  

  useEffect(() => {
    totalOrcamento().then((t) => somaTotal(t));
  }, [freteFixo]);

  useEffect(() => {
    totalOrcamento().then((t) => somaTotal(t));
  }, [freteFixo, despesas, descontoFrete, produtoCar]);

  const handclick = () => {
    setLoading(true);
  
    if (!pagamentoId) {
      setLoadingMensagem(
        'Não é possível gerar um orçamento sem escolher um tipo de pagamento'
      );
      setLoadingBtn('OK');
      return;
    }

    const checkoutData = {
      validade: validade,
      freteFixo: freteFixo,
      precoFinal: somaProdutos.total + freteFixo - descontoFrete + despesas,
      status: 'feito',
      arquivo: fileName,
      nome: clienteCar.nome,
      telefone: clienteCar.telefone,
      prazoEntrega: validade,
      pagamento: { id: pagamentoId },
      clienteId: { id: clienteCar.id },
      vendedor: vendedor,
      negociacao: negociacao,
      descontoFrete: descontoFrete,
      despesas: despesas,
      observacoes: observacoes,
      embarque: embarque,
      tipoFrete: tipoFrete,
      produtoCar: produtoCar,
      pagamentoNome: pagamento[0].nome,
      produtos: produtoCar.map((produto) => ({
        SKU: produto.SKU || 'Não especificado',
        ipi: produto.ipi || 0,
        valor: somaProdutos.total,
        valorUn: somaProdutos.valorUn,
        quantidade: produto.quantidade,
        valorFrete: produto.valorFrete,
        valorIPI: somaProdutos.totalIpi,
        valorTotal: somaProdutos.total + freteFixo - descontoFrete + despesas,
        produto: produto.produto || {},
      })),

    };    

    try {
      sessionStorage.setItem('checkoutData', JSON.stringify(checkoutData));
      setClearLoading(true);
      navigate('/vendedor/checkoutReview');
    } catch (error) {
      console.error('Erro ao salvar dados:', error);
      setLoadingMensagem('Erro ao processar os dados. Tente novamente.');
      setLoadingBtn('OK');
    }
  };  

  return (
    <div className="container">
      <div
        style={{
          display: 'flex',
          borderRadius: '0px 0px 48px 48px',
          backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%), url(${assets.images.bgCheckout})`,
          backgroundColor: '#136033',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundBlendMode: 'multiply, screen, normal',
          padding: ' 32px 200px',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Title title="Checkout" />
        <Step items={items} />
      </div>
      <Box
        style={{
          display: 'flex',
          gap: '22px',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '40px',
        }}
      >
        <Box
          style={{
            display: 'flex',
            gap: '75px',
            justifyContent: 'center',
            flexWrap: 'wrap',
            width: '100%',
          }}
        >
          <Box className="white-bg" width={'40%'}>
            <p className="titulos" style={{ marginBottom: 32 }}>
              Detalhes do pedido
            </p>
            <DetalhesCliente
              style={{ flex: '1' }}
              nome={clienteCar.nome}
              telefone={clienteCar.telefone}
              handValidade={handValidade}
              handEmbarque={handEmbarque}
              pagamento={pagamento}
              handPagamento={handPagamento}
              freteFixo={freteFixo}
              handDespesas={handDespesas}
              despesas={despesas}
              tipoFrete={tipoFrete}
              setTipoFrete={setTipoFrete}
              descontoFrete={descontoFrete}
              handFreteFixo={handFreteFixo}
              handFreteDesconto={handFreteDesconto}
              somaProdutos={somaProdutos}
              handFile={handFile}
              condicao={listaNegociacao}
              negociacao={negociacao}
              handNegociacao={setNegociacao}
            />
            <div>
              <p className="titulos" style={{ marginTop: 32, marginBottom: 8 }}>
                Observações
              </p>
              <textarea
                className="textArea"
                value={observacoes}
                onChange={(e) => setObservacoes(e.target.value)}
                rows={6}
                cols={50}
                placeholder="Insira aqui sua observação..."
              />
            </div>
            <DetalhesVendodor vendedor={vendedor} />
          </Box>
          <Box  width={'50%'}>
            <DetalhesCompra
              produtos={produtoCar}
              despesas={despesas}
              somaProdutos={somaProdutos}
              freteFixo={freteFixo}
              descontoFrete={descontoFrete}
              clienteCar={clienteCar}
               updateProdutoQuantidade={updateProdutoQuantidade}
            />
            <button className="btn-v-checkout" onClick={handclick}>
              CONTINUAR ORÇAMENTO{' '} 
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 2.25C10.5716 2.25 8.68657 2.82183 7.08319 3.89317C5.47982 4.96451 4.23013 6.48726 3.49218 8.26884C2.75422 10.0504 2.56114 12.0108 2.93735 13.9021C3.31355 15.7934 4.24215 17.5307 5.60571 18.8943C6.96928 20.2579 8.70656 21.1865 10.5979 21.5627C12.4892 21.9389 14.4496 21.7458 16.2312 21.0078C18.0127 20.2699 19.5355 19.0202 20.6068 17.4168C21.6782 15.8134 22.25 13.9284 22.25 12C22.2473 9.41498 21.2192 6.93661 19.3913 5.10872C17.5634 3.28084 15.085 2.25273 12.5 2.25ZM12.5 20.25C10.8683 20.25 9.27326 19.7661 7.91655 18.8596C6.55984 17.9531 5.50242 16.6646 4.878 15.1571C4.25358 13.6496 4.0902 11.9908 4.40853 10.3905C4.72685 8.79016 5.51259 7.32015 6.66637 6.16637C7.82016 5.01259 9.29017 4.22685 10.8905 3.90852C12.4909 3.59019 14.1497 3.75357 15.6571 4.37799C17.1646 5.00242 18.4531 6.05984 19.3596 7.41655C20.2661 8.77325 20.75 10.3683 20.75 12C20.7475 14.1873 19.8775 16.2843 18.3309 17.8309C16.7843 19.3775 14.6873 20.2475 12.5 20.25ZM16.7806 11.4694C16.8504 11.539 16.9057 11.6217 16.9434 11.7128C16.9812 11.8038 17.0006 11.9014 17.0006 12C17.0006 12.0986 16.9812 12.1962 16.9434 12.2872C16.9057 12.3783 16.8504 12.461 16.7806 12.5306L13.7806 15.5306C13.6399 15.6714 13.449 15.7504 13.25 15.7504C13.051 15.7504 12.8601 15.6714 12.7194 15.5306C12.5786 15.3899 12.4996 15.199 12.4996 15C12.4996 14.801 12.5786 14.6101 12.7194 14.4694L14.4397 12.75H8.75C8.55109 12.75 8.36033 12.671 8.21967 12.5303C8.07902 12.3897 8 12.1989 8 12C8 11.8011 8.07902 11.6103 8.21967 11.4697C8.36033 11.329 8.55109 11.25 8.75 11.25H14.4397L12.7194 9.53063C12.5786 9.38989 12.4996 9.19902 12.4996 9C12.4996 8.80098 12.5786 8.61011 12.7194 8.46937C12.8601 8.32864 13.051 8.24958 13.25 8.24958C13.449 8.24958 13.6399 8.32864 13.7806 8.46937L16.7806 11.4694Z"
                  fill="#23C265"
                />
              </svg>
            </button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Checkout;
